module.exports = __webpack_public_path__ + "img/pavel.88d5dc03.webp";